import React from "react";
import { Signup } from "./SignupComponents/Signup";

export const MainSignin = () => {
  return (
    <view>
      <Signup />
    </view>
  );
};
